// Vindely 19/10 (Elias): «Lägg i korgen» på produktkorten, fast köpknapp högst upp på varans sida
// och flaggrutan. Lägger i korgen som temats egen produktform (samma händelse), så att korgen öppnas och
// korgikonen räknar upp. Utan skript skickas kortets formulär som vanligt till /cart/add.
import { CartLinesUpdateEvent } from '@shopify/events';
import { fetchConfig } from '@theme/utilities';

async function fetchCart() {
  const cartItems = document.querySelector('cart-items-component');
  if (cartItems) {
    await customElements.whenDefined('cart-items-component');
    return cartItems.fetchCartData();
  }
  const response = await fetch(`${Theme.routes.cart_url}.json`, {
    headers: { Accept: 'application/json' },
    credentials: 'same-origin',
  });
  return response.json();
}

async function addToCart(form, submitter) {
  const formData = new FormData(form);
  if (submitter?.name === 'id') formData.set('id', submitter.value);
  const sectionIds = [...document.querySelectorAll('cart-items-component')]
    .map((element) => element.dataset.sectionId)
    .filter(Boolean);
  if (sectionIds.length) formData.append('sections', sectionIds.join(','));

  const deferred = CartLinesUpdateEvent.createPromise();
  form.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: String(formData.get('id')), quantity: 1 }],
      promise: deferred.promise,
    })
  );

  const config = fetchConfig('javascript', { body: formData });
  let response;
  try {
    response = await fetch(Theme.routes.cart_add_url, {
      ...config,
      headers: { ...config.headers, Accept: 'text/html' },
    }).then((result) => result.json());
  } catch (error) {
    deferred.reject(error);
    return 'network';
  }

  // Varan är redan tillagd här (eller avvisad av Shopify): skicka aldrig formuläret en gång till.
  const ajaxCart = await fetchCart().catch(() => null);
  deferred.resolve({
    cart: ajaxCart ? CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart) : undefined,
    detail: {
      items: ajaxCart?.items ?? [],
      source: 'vindely-kop',
      sourceId: form.dataset.productId,
      itemCount: 1,
      productId: form.dataset.productId,
      sections: response.sections,
      didError: Boolean(response.status),
    },
  });
  return response.status ? 'error' : 'ok';
}

document.addEventListener('submit', async (event) => {
  const form = event.target instanceof HTMLFormElement ? event.target : null;
  if (!form?.hasAttribute('data-vindely-kop')) return;
  event.preventDefault();
  if (form.dataset.upptagen) return;
  form.dataset.upptagen = 'ja';
  const buttons = form.querySelectorAll('button');
  buttons.forEach((button) => button.setAttribute('aria-disabled', 'true'));
  const submitter = event.submitter;
  const result = await addToCart(form, submitter);
  buttons.forEach((button) => button.removeAttribute('aria-disabled'));
  delete form.dataset.upptagen;
  if (result === 'network') {
    if (submitter?.name === 'id') form.insertAdjacentHTML('beforeend', `<input type="hidden" name="id" value="${submitter.value}">`);
    HTMLFormElement.prototype.submit.call(form);
    return;
  }
  form.querySelector('details[open]')?.removeAttribute('open');
});

// Stäng flaggrutan och kortens val vid klick utanför eller Esc.
const closeOpen = (except) => {
  document.querySelectorAll('.vindely-flagga[open], .vindely-v2-kop__val[open]').forEach((details) => {
    if (details !== except) details.removeAttribute('open');
  });
};
document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  closeOpen(target?.closest('.vindely-flagga, .vindely-v2-kop__val'));
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const open = document.querySelector('.vindely-flagga[open], .vindely-v2-kop__val[open]');
  if (!open) return;
  open.removeAttribute('open');
  open.querySelector('summary')?.focus();
});

// Fast köpknapp högst upp: visas när varans riktiga köpknapp har scrollats upp ur bild.
function setupStickyBar() {
  const bar = document.querySelector('[data-vindely-fast]');
  const productId = bar?.dataset.productId;
  const buttonSelector = `product-form-component[data-product-id="${productId}"] .add-to-cart-button`;
  const realButton = document.querySelector(buttonSelector);
  if (!bar || !realButton) return;
  document.body.append(bar);
  bar.hidden = false;
  const header = document.querySelector('#header-component');
  const price = bar.querySelector('[data-vindely-fast-pris]');

  const syncPrice = () => {
    const pagePrice = document.querySelector(`product-price[data-product-id="${productId}"] .price`);
    if (pagePrice && price) price.textContent = pagePrice.textContent.trim();
  };
  const show = (visible) => {
    if (visible) {
      bar.style.top = `${Math.max(0, header?.getBoundingClientRect().bottom ?? 0)}px`;
      syncPrice();
    }
    bar.toggleAttribute('data-synlig', visible);
    bar.inert = !visible;
  };

  new IntersectionObserver(([entry]) => {
    show(!entry.isIntersecting && entry.boundingClientRect.top < 0);
  }).observe(realButton);

  bar.querySelector('[data-vindely-fast-knapp]')?.addEventListener('click', () => {
    const current = document.querySelector(buttonSelector);
    if (current instanceof HTMLButtonElement) current.click();
  });
  show(false);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupStickyBar);
} else {
  setupStickyBar();
}
